import React,{Component} from 'react'
import {postData} from '.././Api/Config';
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
import Preloader from '../layouts/Preloader';


class PublisherModal extends Component {
    state={
        publisher_name:"",
        publisher_error:"",
        isloader:false
       }

    componentDidMount(){
        M.Modal.init(this.PublisherModal, {});
         let input = document.getElementById('publisher_name');
            input.focus()
    }
    
    componentDidUpdate(prevProps, prevState, snapshot){
        if (this.props.name !== prevProps.name) {
            // console.log(this.props.name)
            this.setState({
                publisher_name: this.props.name
            })
        }
    }

     IsValidate=()=>{
         
        if(this.state.publisher_name.trim().length===0){
            this.setState({
                publisher_error:"* empty name!",
            })
            return false;
        }else{
            this.setState({
                publisher_error:"",
            })
        }
        return true;
    }

     handlerSubmit=(e)=>{
        e.preventDefault();
        
        if(this.IsValidate()){
            this.setState({isloader:true})
            let request={}
            let msg = "";
           if(this.props.Id==="New publisher"){
            request = {
                name:this.state.publisher_name
            }
            msg="added new publisher....!"

            document.getElementById("publisher_name").value="";
            this.setState({publisher_name:""})
            }else{
                request = {
                    name:this.state.publisher_name,
                    id:this.props.Id
                }
                msg="updated publisher...!"
            }
            postData('publishers',request).then(res=>{
               this.props.getAllPublishers();
               this.setState({isloader:false})
               M.toast({html: msg});
               let instance = M.Modal.getInstance(this.PublisherModal);
               instance.close();
            //    instance.destory();
            }).catch(err=>{
                this.setState({isloader:false})
                M.toast({html: "Something went wrong..!"});
                console.log(err);
            })
                
        }
    }

    handlerChange=(e)=>{
        // change in input set to state
        this.setState({
            [e.target.id]:e.target.value
        })
    }

    render(){
     
      return (
          
        <div>
       
             <div ref={Modal => {this.PublisherModal = Modal;}} id={this.props.Id}  className="modal">
             <div className="modal-content" >
             {this.state.isloader?<Preloader />:null}
             <div className="col l12 m6">
            {/* startOf new row */}
             <div className="row ">
             
                  {/* form start  */}
                <form onSubmit={this.handlerSubmit} className="col s12">
                
                <h5 className="center-align">{this.props.Id==="New publisher"?this.props.Id:"Update publisher"}</h5>
              
                <div className="row valign-wrapper">
                    
                <div className="input-field col l10 s12  valign">
                    <input id="publisher_name" type="text" value={this.state.publisher_name} onChange={this.handlerChange}/>
                    <label  className="active" htmlFor="publisher_name">Publisher name:</label>
                    <div style={{fontSize:12 ,color:"red"}}>{this.state.publisher_error}</div>
                 </div>
                   <input type="submit" value={this.props.Id==="New publisher"?"Add":"Update"} className="btn btn-medium blue-grey" /> 
              </div>
              </form>
               {/* form end  */}
              </div>
            {/* EndOf new row */}

             </div>
             </div>
             </div>
        </div>
    )
    }
}

export default PublisherModal
